import EventBus from '@/event-bus';
import _toInteger from 'lodash/toInteger';
import _get from 'lodash/get';
import _forEach from 'lodash/forEach';
import _find from 'lodash/find';

/**
 * @description
 * Конструктор обработчика пикселя.
 *
 * @param {Object} config - конфиг для facebook'чных штук
 *
 * @return {void}
 */
var Pixel = function(config) {
  this.config = config;
  this.bindEvents();
};

/**
 * @description
 * Биндилка слушателей событий добавления товара в корзину
 *
 * @return {void}
 */
Pixel.prototype.bindEvents = function() {
  EventBus.subscribe('add_items:insales:cart', this.handleAdd.bind(this));

  EventBus.subscribe('add_checkout:insales:cart', this.handleAdd.bind(this));
};

/**
 * @description
 * Обработка добавления товаров в корзину
 *
 * @param {Object} eventData - ответ из шины событий
 *
 * @return {void}
 */
Pixel.prototype.handleAdd = function(eventData) {
  const items = _get(eventData, 'action.items', {});

  _forEach(items, function(quantity, itemId) {
    if (quantity > 0) {
      this.addItem(itemId, eventData.order_lines);
    } else {
      console.warn('Добавляется 0 товаров');
    }
  }.bind(this));
};

/**
 * @description
 * Отправка информации о добавленном в корзину товаре
 *
 * @param {String|Number} itemId - id варианта позиции корзины
 * @param {Object} order_lines - состав корзины
 *
 * @return {void}
 */
Pixel.prototype.addItem = function(itemId, order_lines) {
  var _itemId = _toInteger(itemId);

  var product = _get(this.config, 'use_variants', false) ? this.getVariant(_itemId, order_lines) : this.getProduct(_itemId, order_lines);

  product.price = this.getPrice(_itemId, order_lines);
  var fbq = window.fbq;

  if (!fbq) {
    return;
  }
  fbq('track', 'AddToCart', {
    currency: this.config.currency_code || 'RUB',
    content_name: product.title,
    value: product.price,
    content_type: 'product',
    content_ids: [ product.id ]
  });
};

/**
 * @description
 * Отправка информации о добавленном в корзину товаре
 *
 * @param {Number} itemId - id варианта позиции корзины
 * @param {Object} order_lines - состав корзины
 *
 * @return {void}
 */
Pixel.prototype.getProduct = function(itemId, order_lines) {
  return _get(_find(order_lines, { variant_id: itemId }), 'product');
};

/**
 * @description
 * Отправка информации о цене товара
 *
 * @param {Number} itemId - id варианта позиции корзины
 * @param {Object} order_lines - состав корзины
 *
 * @return {void}
 */
Pixel.prototype.getPrice = function(itemId, order_lines) {
  return _get(_find(order_lines, { variant_id: itemId }), 'sale_price');
};

/**
 * @description
 * Отправка информации о добавленном в корзину варианте
 *
 * @param {Number} itemId - id варианта позиции корзины
 * @param {Object} order_lines - состав корзины
 *
 * @return {void}
 */
Pixel.prototype.getVariant = function(itemId, order_lines) {
  return _find(order_lines, { variant_id: itemId });
};

export default Pixel;
